import React from 'react';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import GeometricBackground from '@/components/GeometricBackground';
import HeroMockup from '@/components/HeroMockup';
import HomeFlowShowcase from '@/components/HomeFlowShowcase';
import { Link } from 'react-router-dom';

const HomePage: React.FC = () => {
  // Home page should NOT redirect - it should always show the home page
  // Users can navigate to dashboard via header profile dropdown if logged in
  return (
    <>
      <Helmet>
        <title>Arrangelly - for Teaching Music</title>
        <meta
          name="description"
          content="Professional music education platform. Get started today."
        />
      </Helmet>

      <div className="relative min-h-screen overflow-hidden">
        <GeometricBackground />

        <section className="relative pt-20 pb-32 lg:pt-32 lg:pb-40">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                className="text-left z-10"
              >
                <div className="inline-block px-4 py-1.5 rounded-full bg-violet-100/80 border border-violet-200/90 text-violet-800 text-sm font-medium mb-6 backdrop-blur-sm">
                  ✨ Premium Music Education Platform
                </div>

                <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
                  <span className="bg-clip-text text-transparent bg-gradient-to-r from-primary via-violet-500 to-secondary">
                    Compose your career
                  </span>
                </h1>

                <p className="text-lg md:text-xl text-slate-600 mb-10 max-w-lg leading-relaxed">
                  Empower your music teaching with our all-in-one platform. Streamline your lessons,
                  manage students, and grow your studio with ease.
                </p>

                <div className="flex flex-col sm:flex-row gap-4">
                  <Button
                    asChild
                    className="h-14 px-8 text-lg bg-accent hover:bg-accent/90 text-white rounded-full shadow-lg shadow-accent/20 transition-all hover:scale-105"
                  >
                    <Link to="/pricing">Get Started Today</Link>
                  </Button>

                  <Button
                    asChild
                    variant="outline"
                    className="h-14 px-8 text-lg border-slate-300 text-slate-800 hover:bg-slate-100 rounded-full backdrop-blur-sm transition-all hover:scale-105"
                  >
                    <Link to="/features">Learn More</Link>
                  </Button>
                </div>

              </motion.div>

              <div className="relative z-10">
                <HeroMockup />
              </div>
            </div>
          </div>
        </section>

        <HomeFlowShowcase />
      </div>
    </>
  );
};

export default HomePage;


